'use client';

import React from 'react';
import SummaryRow from '../../components/lakeview/SummaryRow';

const CustomerSummary = ({ customer, fields }) => {
  if (!customer) return null;

  return (
    <>
      {fields.map((field) => {
        // Pole id pomijamy w podsumowaniu
        if (field.type === 'unvisible') {
          return null;
        }

        const value = customer[field.name];

        return (
          <SummaryRow
            key={field.name}
            label={field.label}
            value={value || '-'}
            show={!!value}
          />
        );
      })}
    </>
  );
};

export default CustomerSummary;
